import React, { useState } from 'react';
import TextArea from '../components/TextArea';
import exampleQuoteData from '../../data/exampleQuoteData.json';
import { useDispatch, useSelector } from 'react-redux';
import { setQuoteDataAction } from '../reduxstore/actions/quoteActions';
import AddDocumentsCard from '../components/QuoteReviewComponents/AddDocumentsCard';
import InformationCard from '../components/QuoteReviewComponents/InformationCard/InformationCard';
import QuoteInformationCard from '../components/QuoteReviewComponents/QuoteInformationCard/QuoteInformationCard';

const GetQuoteReviewScreen = ({ handleTabChange }) => {
  const dispatch = useDispatch();
  const quoteImage = useSelector((state) => state.quoteReducer.quote.image);
  const [quoteData, setQuoteData] = useState(exampleQuoteData);
  dispatch(setQuoteDataAction(quoteData));

  return (
    <div className="flex">
      <div className="flex flex-col flex-grow overflow-y-auto">
        <div className=" pb-7 space-y-3">
          <div className="flex flex-row w-full space-x-3">
            <img
              alt="ProductImg"
              src={quoteImage}
              className="rounded-lg w-96 h-[267px]"
            />
            <div className="w-full flex-grow">
              <QuoteInformationCard
                type={'quoteInformation'}
                quoteNo={quoteData?.quoteNo}
              />
            </div>
          </div>
          <InformationCard type={'processAndFinish'} />
          <InformationCard type={'verificationAndValidation'} />
          <InformationCard type={'logistic'} />
          <AddDocumentsCard />
          <div className="flex flex-row ">
            <div className="basis-1/2">
              <TextArea heading="Project Description" rows={10} cols={57} />
            </div>
          </div>
          <div className="flex flex-row items-center justify-center space-x-4">
            <button
              className="rounded-full px-8 py-2 text-[18px] text-left my-1 border-[1px] border-black"
              onClick={() => handleTabChange('drop_files')}
            >
              Cancel
            </button>
            <button
              className="rounded-full px-8 py-2 text-[18px] text-left my-1 bg-gradient-to-r from-[#8B5CF6] to-[#60A5FA] text-white"
              onClick={() => handleTabChange('submit_quote')}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetQuoteReviewScreen;
